import { useMemo } from 'react'
import { useTable, ColumnInstance, Row } from 'react-table'
import {
  useQueryResponseData,
  useQueryResponseLoading,
} from '../../../medicalCondition/list/core/QueryResponseProvider'
import { MedicalCondition } from '../../../medicalCondition/list/core/_models'
import { ListPagination } from '../components/pagination/ListPagination'
import { KTCardBody } from '../../../../_metronic/helpers'
import { CustomHeaderColumn } from './columns/CustomHeaderColumn'
import { MedicalConditionColumns } from './columns/_columns'
import { CustomRow } from './columns/CustomRow'
import { LoadingListLoading } from '../../../../utils/loading/loadingListLoading'

const Table = () => {
  const medicalCondition = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => medicalCondition, [medicalCondition])
  const columns = useMemo(() => MedicalConditionColumns, [])
  const { getTableProps, getTableBodyProps, headers, rows, prepareRow } = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<MedicalCondition>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
              <td className='text-center min-w-100px'>Ações</td>
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<MedicalCondition>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    Nenhum registro encontrado
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ListPagination />
      {isLoading && <LoadingListLoading title="Carregando" />}

    </KTCardBody>
  )
}

export { Table }
